import { TableCell, styled } from "@mui/material"

/**
 * Styled table cell component to be used across the app.
 * Reduces table cell padding
 */
const AppTableCell = styled(TableCell)(({ theme }) => ({
    paddingLeft: 0,
    paddingRight: theme.spacing(1.5),
}))

export default AppTableCell
